import { TFunction } from "i18next";
import { ReactNode } from "react";

import { IURLSearchParams } from "@/browser";
import { ITabOption, TTabOption } from "@/components/Tabs";
import { IJobRequestFilter } from "@/data/job-requests";

import { mapToJobRequestURLFilter } from "../Filters";

export const buildJobsTabOption = (
  value: string,
  label: string,
  icon: string,
  searchParams?: IURLSearchParams,
  renderContent?: (active: boolean) => ReactNode,
  onClick?: () => void,
): ITabOption => ({
  type: "option",
  icon,
  iconColorActive: "default",
  iconColor: "grey4",
  value,
  label,
  searchParams,
  pathName: "job-requests",
  renderContent,
  onClick,
});

export const buildJobsTabOptions = (
  t: TFunction,
  filters?: IJobRequestFilter[],
  filtersOnly?: boolean,
  renderFilterTabContent?: (active: boolean, filter: IJobRequestFilter) => ReactNode,
  onJobsClick?: () => void,
) => {
  const options: TTabOption[] = [];

  if (!filtersOnly) {
    options.push({
      type: "group",
      options: [
        buildJobsTabOption(
          "all-jobs",
          t("JOB_REQUESTS.LIST.ALL_JOBS.TAB_NAME"),
          "others",
          undefined,
          undefined,
          onJobsClick,
        ),
        buildJobsTabOption("recommended", t("JOB_REQUESTS.LIST.RECOMMENDED.TAB_NAME"), "like", {
          filtersConfig: { recommendedOnly: true },
        }),
        buildJobsTabOption("my-saved-jobs", t("JOB_REQUESTS.LIST.MY_SAVED_JOBS.TAB_NAME"), "bookmark", {
          filtersConfig: { favouritesOnly: true },
        }),
      ],
    });
  }

  if (filters?.length) {
    options.push({
      type: "group",
      options: filters.map(filter =>
        buildJobsTabOption(
          `search-${filter.id.toString()}`,
          filter.name,
          "filters",
          {
            filtersConfig: mapToJobRequestURLFilter(filter),
          },
          active => (renderFilterTabContent ? renderFilterTabContent(active, filter) : undefined),
        ),
      ),
    });
  }

  return options;
};
